<template>
  <div class="game-timer__circle">
    <link href="https://fonts.googleapis.com/css?family=Raleway:400,300,600,800,900" rel="stylesheet" type="text/css">
    <div id="container"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState } from 'vuex';

const ProgressBar = require('progressbar.js');

export default {
  name: 'timer',
  props: ['seconds', 'userAnswer'],
  data() {
    return {
      timeIsUp: false,
      secondsElapsed: 0,
      timer: null,
      onlyOneCicle: false,
      questionAnswerTime: 0,
    };
  },
  created() {
    console.log('in Time created hook');
    this.initQuestionData();
  },
  methods: {
    initQuestionData() {
      this.timeIsUp = false;
      this.initAndStartTimer();
    },
    initAndStartTimer() {
      clearInterval(this.timer);
      this.onlyOneCicle = true;
      this.secondsElapsed = 0;
      this.questionAnswerTime = this.roundTimeList[0];
      if (this.seconds) {
        this.questionAnswerTime = this.seconds;
      }
      this.displayedAnswerTime = this.questionAnswerTime;
      /* eslint-disable */
      this.$nextTick(() => {
        this.timer = setInterval(() => {
          if (this.onlyOneCicle) {
            this.onlyOneCicle = false;
            $("#container").html("");
            const bar = new ProgressBar.Circle(container, {
              vm: this,
              color: '#aaa',
              // This has to be the same size as the maximum width to
              // prevent clipping
              strokeWidth: 10,
              trailWidth: 9,
              easing: 'easeInOut',
              duration: this.questionAnswerTime,
              text: {
                autoStyleContainer: false
              },
              from: { color: '#ffffff', width: 8 },
              to: { color: '#ffffff', width: 8 },
              // Set default step function for all animate calls
              step: function (state, circle) {
                circle.path.setAttribute('stroke', state.color);
                circle.path.setAttribute('stroke-width', state.width);
                circle.path.setAttribute('stroke', state.color);
                circle.setText(circle._opts.vm.displayedAnswerTime / 1000);
              }
            }); // var bar
            bar.animate(1.0);
          }
          this.secondsElapsed += 1;
          this.displayedAnswerTime -= 1000;
          if ((this.secondsElapsed * 1000)=== this.questionAnswerTime || this.userAnswer) {
            this.second = 0;
            clearInterval(this.timer);
          }
        }, 1000);
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'roundTimeList',
    ]),
    ...mapState('game', [
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/Timer.vue